import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import {
    EPortabilityDatesActions,
    GetPortabilityDates, GetPortabilityDatesSuccess, GetPortabilityDatesFailure
} from '../actions/portability-dates.actions';
import { HttpErrorResponse } from '@angular/common/http';
import { PortabilityDatesService } from '../../services/portability-dates.service';
import { AbstractEffects } from '../../abstract.effects';

@Injectable()
export class PortabilityDatesEffects extends AbstractEffects {

    constructor(
      private actions: Actions,
      private portabilityDatesService: PortabilityDatesService,
      public override store: Store<any>
    ) {
        super(store);
    }

    getPortabilityDates = createEffect(() => this.actions.pipe(
        ofType<GetPortabilityDates>(EPortabilityDatesActions.GetPortabilityDates),
        switchMap(() => this.portabilityDatesService.get()),
        switchMap((response: Array<string>) => of(new GetPortabilityDatesSuccess(response))),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new GetPortabilityDates());
            } else {
                this.DisplayMessage('error_with_retry', 400, new GetPortabilityDatesFailure());
            }
            return throwError(error);
        })
    ));
}
